<template>
  <nav data-role="Header" class="navbar-navbar" v-bind:class="rootClassName">
    <h1 class="navbar-logo">
      <span>
        Madeira
        <span v-html="raw486d"></span>
      </span>
      <br />
      <span>Roots</span>
    </h1>
    <div class="navbar-right-side">
      <div class="navbar-links-container">
        <span class="navbar-text3">{{ text }}</span>
        <span class="navbar-text4">{{ text9 }}</span>
        <router-link to="/aboutus" class="navbar-navlink">
          {{ text1 }}
        </router-link>
        <router-link to="/tours" class="navbar-navlink1">{{ text2 }}</router-link>
        <router-link to="/landing-page" class="navbar-navlink2">
          {{ text3 }}
        </router-link>
      </div>
      <a href="#main-section" class="navbar-link">
        <main-btn button="Book now"></main-btn>
      </a>
    </div>
    <div data-type="BurgerMenu" class="navbar-burger-menu">
      <svg viewBox="0 0 1024 1024" class="navbar-burger-menu">
        <path
          d="M810.667 725.333h-597.333c-47.061 0-85.333 38.272-85.333 85.333s38.272 85.333 85.333 85.333h597.333c47.061 0 85.333-38.272 85.333-85.333s-38.272-85.333-85.333-85.333z"
        ></path>
        <path
          d="M810.667 426.667h-597.333c-47.061 0-85.333 38.272-85.333 85.333s38.272 85.333 85.333 85.333h597.333c47.061 0 85.333-38.272 85.333-85.333s-38.272-85.333-85.333-85.333z"
        ></path>
        <path
          d="M810.667 128h-597.333c-47.061 0-85.333 38.272-85.333 85.333s38.272 85.333 85.333 85.333h597.333c47.061 0 85.333-38.272 85.333-85.333s-38.272-85.333-85.333-85.333z"
        ></path>
      </svg>
    </div>
    <div data-type="MobileMenu" class="navbar-mobile-menu">
      <div class="navbar-nav">
        <div class="navbar-top">
          <h1>{{ Logo }}</h1>
          <div data-type="CloseMobileMenu" class="navbar-close-menu">
            <svg viewBox="0 0 1024 1024" class="navbar-icon3">
              <path
                d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"
              ></path>
            </svg>
          </div>
        </div>
        <div class="navbar-right-side1">
          <div class="navbar-links-container1">
            <router-link to="/landing-page" class="navbar-navlink3">
              {{ text5 }}
            </router-link>
            <router-link to="/landing-page" class="navbar-navlink4">
              {{ text6 }}
            </router-link>
            <router-link to="/tours" class="navbar-navlink5">
              {{ text7 }}
            </router-link>
            <router-link to="/landing-page" class="navbar-navlink6">
              {{ text8 }}
            </router-link>
          </div>
          <a href="#main-section" class="navbar-link1">
            <main-btn button="Book now"></main-btn>
          </a>
        </div>
      </div>
      <div class="navbar-follow-container">
        <span class="navbar-text5">{{ text4 }}</span>
        <div class="navbar-icons-container">
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noreferrer noopener"
            class="navbar-link2"
          >
            <svg viewBox="0 0 877.7142857142857 1024" class="navbar-icon5">
              <path
                d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"
              ></path>
            </svg>
          </a>
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noreferrer noopener"
            class="navbar-link3"
          >
            <svg viewBox="0 0 602.2582857142856 1024" class="navbar-icon7">
              <path
                d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"
              ></path>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import MainBtn from './main-btn'

export default {
  name: 'Navbar',
  props: {
    text2: {
      type: String,
      default: 'Tour Packages',
    },
    text6: {
      type: String,
      default: 'About',
    },
    text8: {
      type: String,
      default: 'Contact',
    },
    text3: {
      type: String,
      default: 'Contact',
    },
    text: {
      type: String,
      default: 'Home',
    },
    text4: {
      type: String,
      default: 'Follow us on',
    },
    Logo: {
      type: String,
      default: 'Madeira Roots',
    },
    text7: {
      type: String,
      default: 'Tour Packages',
    },
    text5: {
      type: String,
      default: 'Home',
    },
    rootClassName: String,
    text1: {
      type: String,
      default: 'About',
    },
    text9: {
      type: String,
      default: 'Blog',
    },
  },
  components: {
    MainBtn,
  },

  data() {
    return {
      raw486d: ' ',
    }
  },
}
</script>

<style scoped>
.navbar-navbar {
  width: 100%;
  display: flex;
  padding: var(--dl-space-space-doubleunit);
  max-width: 1000px;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.navbar-logo {
  color: #ffffff;
}
.navbar-right-side {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.navbar-links-container {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.navbar-text3 {
  color: #ffffff;
  cursor: pointer;
  transition: 0.3s;
  margin-right: var(--dl-space-space-doubleunit);
  text-decoration: none;
}
.navbar-text3:hover {
  border-color: #f5f5f5;
  border-width: 0px;
  border-bottom-width: 1px;
}
.navbar-text4 {
  color: #ffffff;
  cursor: pointer;
  transition: 0.3s;
  margin-right: var(--dl-space-space-doubleunit);
  text-decoration: none;
}
.navbar-text4:hover {
  border-color: #f5f5f5;
  border-width: 0px;
  border-bottom-width: 1px;
}
.navbar-navlink {
  color: #ffffff;
  cursor: pointer;
  transition: 0.3s;
  margin-right: var(--dl-space-space-doubleunit);
  text-decoration: none;
}
.navbar-navlink:hover {
  border-color: #f5f5f5;
  border-width: 0px;
  border-bottom-width: 1px;
}
.navbar-navlink1 {
  color: #ffffff;
  cursor: pointer;
  transition: 0.3s;
  margin-right: var(--dl-space-space-doubleunit);
  text-decoration: none;
}
.navbar-navlink1:hover {
  border-color: #f5f5f5;
  border-width: 0px;
  border-bottom-width: 1px;
}
.navbar-navlink2 {
  color: #ffffff;
  cursor: pointer;
  transition: 0.3s;
  margin-right: var(--dl-space-space-doubleunit);
  text-decoration: none;
}
.navbar-navlink2:hover {
  border-color: #f5f5f5;
  border-width: 0px;
  border-bottom-width: 1px;
}
.navbar-link {
  display: contents;
}
.navbar-burger-menu {
  display: none;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.navbar-burger-menu {
  fill: #ffffff;
  width: 24px;
  height: 24px;
}
.navbar-mobile-menu {
  top: 0px;
  flex: 0 0 auto;
  left: 0px;
  width: 100%;
  height: 100%;
  display: none;
  padding: var(--dl-space-space-doubleunit);
  z-index: 100;
  position: absolute;
  flex-direction: column;
  justify-content: space-between;
  background-color: #fff;
}
.navbar-nav {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.navbar-top {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-doubleunit);
  flex-direction: row;
  justify-content: space-between;
}
.navbar-close-menu {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.navbar-icon3 {
  width: 24px;
  height: 24px;
}
.navbar-right-side1 {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
}
.navbar-links-container1 {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  flex-direction: column;
  justify-content: space-between;
}
.navbar-navlink3 {
  margin-bottom: 8px;
  text-decoration: none;
}
.navbar-navlink4 {
  margin-bottom: 8px;
  text-decoration: none;
}
.navbar-navlink5 {
  margin-bottom: 8px;
  text-decoration: none;
}
.navbar-navlink6 {
  text-decoration: none;
}
.navbar-link1 {
  display: contents;
}
.navbar-follow-container {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
}
.navbar-text5 {
  padding-bottom: var(--dl-space-space-halfunit);
}
.navbar-icons-container {
  width: 100px;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: center;
}
.navbar-link2 {
  display: contents;
}
.navbar-icon5 {
  width: 24px;
  height: 24px;
}
.navbar-link3 {
  display: contents;
}
.navbar-icon7 {
  width: 24px;
  height: 24px;
}



@media(max-width: 767px) {
  .navbar-right-side {
    display: none;
  }
  .navbar-burger-menu {
    display: flex;
  }
}
</style>
